<template>
    <v-dialog width="500" persistent v-model="exibirModal">
        <v-card>
            <v-card-title class="primary modal-title pb-1 pt-1" primary-title>
                <span>Ocorrência Envio de Remessa</span>
                <v-btn flat depressed @click="propagarFecharModal">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text class="az-form-content pa-0">
                <v-layout wrap align-center white class="pa-3">
                    <v-flex xs12 sm12 d-flex>
                        <v-select
                            name="Licitação"
                            key="Licitação"
                            label="Licitação"
                            placeholder="Selecione a Ocorrência da Licitação"
                            :menu-props="{ top: false, offsetY: true }"
                            v-model="dados.ocorrenciaLicitacao"
                            class="required-field"
                            v-validate="'required'"
                            :items="Object.entries(tiposOcorrenciaLicitacao).map(([key, value]) => ({key: value.valor, value: value.texto}))"
                            :error-messages="errors.collect('Licitação')"
                            item-text="value"
                            item-value="key"
                            clearable
                        />
                    </v-flex>
                    <v-flex xs12 sm12 d-flex>
                        <v-select
                            name="Decisão"
                            key="Decisão"
                            label="Decisão"
                            placeholder="Selecione a Decisão da Licitação"
                            :menu-props="{ top: false, offsetY: true }"
                            v-model="dados.decisaoOcorrencia"
                            class="required-field"
                            v-validate="'required'"
                            :items="Object.entries(tiposDecisaoOcorrencia).map(([key, value]) => ({key: value.valor, value: value.texto}))"
                            :error-messages="errors.collect('Decisão')"
                            item-text="value"
                            item-value="key"
                            clearable
                        />
                    </v-flex>
                    <v-flex xs12 sm12 d-flex>
                        <v-textarea
                            v-model="dados.justificativaOcorrencia"
                            class="required-field"
                            v-validate="'required'"
                            rows="2"
                            name="Justificativa"
                            key="Justificativa"
                            label="Justificativa"
                            placeholder="Insira a Justificativa"
                            :error-messages="errors.collect('Justificativa')"
                            :counter="5000"
                            maxlength="5000"
                        />
                    </v-flex>
                </v-layout>
            </v-card-text>

            <v-divider/>

            <v-card-actions class="pa-3">
                <v-btn color="#777" flat @click="propagarFecharModal">
                    Cancelar
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn id="botaorecarregar" class="botao-primario" flat @click="propagarEnviarOcorrencia">
                    Enviar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { tiposDecisaoOcorrencia, tiposOcorrenciaLicitacao } from '@/core/constants'

export default {
    name: 'ModalFormularioOcorrenciaEsfinge',
    props: {
        exibirModal: {
            type: Boolean,
        },
    },
    data() {
        return {
            dados: {
                ocorrenciaLicitacao: '',
                decisaoOcorrencia: '',
                justificativaOcorrencia: '',
            },
            tiposDecisaoOcorrencia,
            tiposOcorrenciaLicitacao
        }
    },
    computed: {
        ehFormularioValido() {
            return this.errors.items.length === 0
        },
    },
    methods: {
        propagarFecharModal() {
            this.$emit('processarFecharModal')
        },
        async propagarEnviarOcorrencia() {
            await this.validarDadosFormulario()
            if (this.ehFormularioValido) {
                this.$emit('processarEnviarAlterarOcorrencia', this.dados)
                this.propagarFecharModal()
            }
        },
        async validarDadosFormulario() {
            return await this.$validator.validate()
        }
    },
}
</script>

<style scoped lang="stylus">
.modal-title
    justify-content space-between

    .v-btn
        padding 0
        margin 0
        color #fff
        box-sizing border-box
        min-width 25px

.botao-primario
    padding 0 25px
    border 1px solid var(--v-primary-base) !important
    background-color var(--v-primary-base) !important
    color #fff !important
    box-sizing border-box
    margin-left 15px !important

</style>
